import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { RouterExtService } from "../../core/router/router-ext.service";
import { GoogleAuthenticationService } from "../../core/login/google-authentication.service";

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  isError = false;

  constructor(private readonly googleAuthenticationService: GoogleAuthenticationService,
              private readonly router: Router,
              private readonly routerExtService: RouterExtService) {}

  ngAfterViewInit() {
    this.googleAuthenticationService.isLoggedIn$.subscribe(loggedIn => {
      if(loggedIn){
          let previous = this.routerExtService.getPreviousUrl();
          if (previous == "/") {
            previous = '/pages/dashboard'
          }
          this.router.navigate([previous]);
      }
    });
  }
}
